import gql from 'graphql-tag';

export const deleteMonLogAlarm = gql`
  mutation deleteMonLogAlarm($id: String) {
    deleteMonLogAlarm(id: $id) {
      value
    }
  }
`;
